import { withStyles } from "@material-ui/core";
import React from "react";

const styles = (theme) => ({
  detail: {
    display: "flex",
    alignItems: "center",
    color: theme.dispatchPanelHeaderColor,
    fontSize: theme.textFontSize,
    margin: "6px 0px 6px",
  },
  label: {
    color: theme.iconColor,
    fontWeight: 400,
    lineHeight: "16px",
    marginRight: 8,
  },
  minWidth: {
    minWidth: 50,
  },
  value: {
    color: theme.dispatchPanelLabelValueColor,
    fontWeight: 600,
    lineHeight: "16px",
    marginRight: 24,
  },
});
const Details = ({ classes, label, value, minWidth }) => {
  return (
    <div className={classes.detail}>
      <span className={`${classes.label} ${minWidth ? classes.minWidth : ""}`}>
        {label}
      </span>
      <span className={classes.value}>{value}</span>
    </div>
  );
};
export default withStyles(styles)(Details);
